import React from 'react';
import * as S from './styled';
import { PRODUCT_NAME } from '../../core/constants';
import { LanguagePicker } from './LanguagePicker';

interface HeaderLogoProps {
  withFlags?: boolean;
  screenId?: string;
}

export const HeaderLogo = ({ withFlags = false, screenId = '' }: HeaderLogoProps) => (
  <S.LogoWrapper $withFlags={withFlags}>
    <S.LogoCluster>
      <S.Text>{PRODUCT_NAME}</S.Text>
      <S.Logo />
    </S.LogoCluster>
    {withFlags && <LanguagePicker screenId={screenId} />}
  </S.LogoWrapper>
);
